export { ApresentarDadosComponentModule } from './apresentar-dados.module';
export { FonteDados, TesteVazio } from './dados';
export { FonteDadosMock } from './mock';
